<template>
  <UModal
    :title="t('comps.modal_who_are_we.title')"
    :description="name"
  >
    <UButton
      variant="link"
      color="inherit"
      label="Hvem er vi?"
    />
    <template #body>
      <LayoutLogo
        :light-mode="false"
        class="flex justify-center my-6"
      />
      <LayoutP><span v-html="t('comps.modal_who_are_we.text', { email })" /></LayoutP>
      <AppNgoPerson />
      <br><br>
      <p
        class="block w-full text-center"
        v-text="t('comps.modal_who_are_we.info', { org_number, address, bank_account })"
      />
    </template>
  </UModal>
</template>

<script lang="ts" setup>
import { UModal } from '#components'

const { data: { ngo: { name, email, org_number, address, bank_account } } } = getData()
</script>
